module.exports = __webpack_public_path__ + "img/bannerMobile.753bdf57.webp";